import { type LicenseMessageDisposition } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { UsageCard } from "./UsageOverviewCard";
type LimitUsageCardProps = {
    name: string;
    currentUsage: number;
    licensedLimit: number;
    disposition: LicenseMessageDisposition;
    isUnlimited: boolean;
    contextualHelp?: React.ReactNode;
};
export function LimitUsageCard({ name, currentUsage, licensedLimit, disposition, isUnlimited, contextualHelp }: LimitUsageCardProps) {
    // Prevent rendering if licensedLimit is 0 to avoid division by zero in resource usage calculations.
    if (!name || !!!licensedLimit)
        return null;
    const subtitle = isUnlimited ? `${currentUsage}/Unlimited` : `${currentUsage}/${licensedLimit}`;
    const circularProgressPercentage = Math.min(1, currentUsage / licensedLimit) * 100; // 100% will be shown if limits are exceeded
    return <UsageCard title={name} subtitle={subtitle} percentage={circularProgressPercentage} disposition={disposition} isUnlimited={isUnlimited} contextualHelp={contextualHelp}/>;
}
